import { get, getAll } from "../utilities/querySelector";

const forms = getAll("[data-form-submit-on-change]");

if (forms) {
    forms.forEach((form) => {
        const inputs = getAll("input, select", form);
        inputs.forEach((input) =>
            input.addEventListener("change", () => {
                form.submit();
            })
        );
    });
}

const footerForm = get(".site-footer .wpcf7-form");
if (footerForm) {
    const dateTimeField = get(".walcf7-datetimepicker", footerForm);
    if (dateTimeField) {
        const tomorrow = new Date();
        const defaultTime = '10:00';
        const currentYear = new Date().getFullYear();
        const endYear = currentYear + 1;

        tomorrow.setDate(tomorrow.getDate() + 1);

        jQuery(dateTimeField).datetimepicker({
            format: "d/m/Y H:i",
            timepicker: true,
            defaultTime: defaultTime,
            minTime: '10:00',
            maxTime: '15:00',
            step: 30,
            minDate: tomorrow,
            yearStart: currentYear,
            yearEnd: endYear,
            scrollMonth: false,
            scrollTime: false,
            scrollInput: false,
            beforeShowDay: function(date) {
                var day = date.getDay();
                // Disable all Mondays & Sunday
                return [(day != 0 && day != 1), ""];
            },
            onChangeMonth: function(currentTime, $input) {
                var currentDate = new Date();
                if (currentTime < currentDate.setMonth(currentDate.getMonth())) {
                    this.setOptions({
                        value: currentDate
                    });
                }
            },
            onChangeYear: function(currentTime, $input) {
                var currentDate = new Date();
                if (currentTime < currentDate.setFullYear(currentDate.getFullYear())) {
                    this.setOptions({
                        value: currentDate
                    });
                }
            }
        });
    }
}
